import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom"; import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../../../../Helper/Context";
import { Loading } from "../../../../../../../../Helper/Loading";
import EnchrochmentSidebar from "../../../EnchrochmentSidebar/EnchrochmentSidebar";
import { HeaderIllegal } from "../../../../IllegalConstructionDashboard/HeaderIllegal";
import { ZoneNameCommanDDL } from "../../../../../../../../Components/IllegalDDL/ZoneNameCommanDDL";
import { Pegination } from "../../../../../../../../Components/Pegination/Pegination";
import ViewURL from "../Modal/ViewURL";
import { GroupAttendanceGetTableDataAPI } from "../../../../../../../../Redux/EnchrochmentDashboardSlice/GroupAttendanceSlice";

export const GroupAttendanceGrid = () => {

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails

    const { t } = useTranslation()

    const [searchParams] = useSearchParams()

    // let YearValue = searchParams.get("YearValue")
    // let MonthValue = searchParams.get("MonthValue")
    // let ZoneValue = searchParams.get("ZoneValue");
    let DashSelect = searchParams.get("DashSelect");
    let Flag = searchParams.get("Flag");
    const ScreenNameTotal = searchParams.get('ScreenNameTotal')

    const [IsPost, setIsPost] = useState(false)

    const [IsClear, setIsClear] = useState(false)
    const [IsSearch, setIsSearch] = useState(false)

    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [showImagePopup, setshowImagePopup] = useState(false)

    const [FromDate, setFromDate] = useState('')
    const [ToDate, setToDate] = useState('')

    const [GridData, setGridData] = useState([])

    // ------------header DDL ------------

    const [YearValue, setYearValue] = useState(sessionStorage.getItem('yearId'))
    const [YearLabel, setYearLabel] = useState(sessionStorage.getItem('yearLable'))
    const [MonthValue, setMonthValue] = useState(sessionStorage.getItem('monthId'))
    const [MonthLabel, setMonthLabel] = useState(sessionStorage.getItem('monthLable'))
    const [ZoneValue, setZoneValue] = useState(sessionStorage.getItem('zoneId'))
    const [ZoneLabel, setZoneLabel] = useState(sessionStorage.getItem('ZoneLable'))

    const [isopen, setIsOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isopen);
    };

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: sessionStorage.getItem('LanguageChange')
    })

    const [ZoneNameID, setZoneNameID] = useState({
        DDL: [],
        ID: ZoneValue && ZoneValue ? ZoneValue : '0',
        Label: ZoneLabel && ZoneLabel ? ZoneLabel : "Select...",
    })


    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setFromDate('')
        setToDate('')
        setZoneNameID({
            ...ZoneNameID,
            ID: 0,
            Label: 'Select...'
        })
    }
    useEffect(() => {
        setCurrentPage(0)
        setFrom(1)
        setTo(10)
    }, [ZoneNameID.ID])

    useEffect(() => {
        const data = {
            M_FinancialYearID: YearValue,
            M_MonthID: MonthValue,
            FromDate: FromDate,
            ToDate: ToDate,
            M_ZoneID: ZoneNameID.ID ? ZoneNameID.ID : ZoneValue,
            T_Encroach_GroupAttendanceID: 0,
            M_WorkTypeID: DashSelect,
            Language: Language.Label,
            M_UserID: UserID,
            FromTop: From,
            ToTop: To,
            token: token,
            Flag: Flag,
        }
        if (Language.Label != null) {
            dispatch(GroupAttendanceGetTableDataAPI({ data }))
        }
    }, [YearValue, MonthValue, DashSelect, From, IsClear, IsSearch, IsPost, Language.Label, FromDate, ToDate, ZoneValue, ZoneNameID.ID])

    const { isLoading, tableData } = useSelector(state => state.GroupAttendanceGetTableData)

    return (
        <>
            {isLoading && <Loading />}
            {/* <div className="container-scroller"> */}

            <HeaderIllegal />
            <div className="wrapper bg-change">
                <EnchrochmentSidebar
                />
                <div className="content1 content mt-1 " style={{}}>
                    <div className="row">
                        <div className="col-12">
                            {/* Group Attendance */}
                            <h5 className="text-dark fw-bold ps-3 pt-2 all_heading_fontsize">
                                {t('EncroachmentDashboard.GroupAttendance')}

                            </h5>
                        </div>
                    </div>
                    <div className="row ps-3 py-2 eic_table_styles" >

                        <div class="col-12 col-lg-2 pt-2">
                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.FromDate')}</label><br />
                            <input
                                className="form-control"
                                id="FromDate"
                                type="date"
                                name="FromDate"
                                value={FromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                            />
                        </div>

                        <div class="col-12 col-lg-2 pt-2">
                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.ToDate')}</label><br />
                            <input
                                className="form-control"
                                id="ToDate"
                                type="date"
                                name="ToDate"
                                value={ToDate}
                                onChange={(e) => setToDate(e.target.value)}
                                min={FromDate}
                            />
                        </div>



                        <div class="col-12 col-lg-3 pt-2">
                            <ZoneNameCommanDDL
                                ZoneNameID={ZoneNameID}
                                setZoneNameID={setZoneNameID}
                                Flag='Insert'
                                ApiFlag='UserWiseZone'
                                data=''
                                IsPost=''
                                Language={Language}
                                ZoneValue={ZoneValue}
                                ZoneLabel={ZoneLabel}
                            />
                        </div>


                        <div className="col-12 col-lg-3 col-md-4  mt-3">
                            <button type="button" className="btn btn-danger mt-4" onClick={handleClear}>Clear</button>
                        </div>

                        <div className="row" >
                            <div className="col-12  " >
                                <div className="table-responsive pt-3">
                                    <table className="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.date')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Day')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ZoneName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.WardName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Pathakname')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ShiftTime')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Intime')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.INPhoto')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.OutTime')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.OutPhoto')}</th>
                                                {
                                                    ((RoleID == 2) || (RoleID == 3) || (RoleID == 4) || (RoleID == 6)) &&
                                                    <th className="text-center">{t('EncroachmentDashboard.OfficerName')}</th>
                                                }

                                                {/* <th className="text-center">{t('EncroachmentDashboard.GroupAttendancetime')}</th>
                                                            <th className="text-center">{t('EncroachmentDashboard.EmployeeName')}</th> */}
                                            </tr>

                                        </thead>

                                        <tbody>
                                            {
                                                tableData && tableData?.length > 0 ? tableData?.map((i, j) => {
                                                    return (
                                                        <tr>

                                                            <td className="py-1" align="center" >{i?.rowNum}</td>
                                                            <td className="nowrap">{i.attendanceDate ? moment(i.attendanceDate).format("DD-MM-YYYY") : '-'}</td>
                                                            <td className="nowrap" >{i.attendanceDay ? i.attendanceDay : '-'}</td>
                                                            <td >{i.zoneName ? i.zoneName : '-'}</td>
                                                            <td >{i.wardName ? i.wardName : '-'}</td>
                                                            <td >{i.pathakName ? i.pathakName : '-'}</td>
                                                            <td >{i.m_Indicator_ShiftName ? i.m_Indicator_ShiftName : '-'}</td>

                                                            <td >{i.in_Time ? i.in_Time : '-'}</td>

                                                            <td className="text-center pt-2">
                                                                {
                                                                    (i.in_Photo == null) ?
                                                                        <span>-</span>
                                                                        :
                                                                        <button className="view_button " onClick={() => handleShowImage(i.in_Photo)}>
                                                                            {/* {t('EncroachmentDashboard.View')} */}
                                                                            <i class="fa-regular fa-image"></i>
                                                                        </button>

                                                                }

                                                            </td>

                                                            <td >{i.out_Time ? i.out_Time : '-'}</td>

                                                            <td className="text-center pt-2">
                                                                {
                                                                    (i.out_Photo == null) ?
                                                                        <span>-</span>
                                                                        :
                                                                        <button className="view_button " onClick={() => handleShowImage(i.out_Photo)}>
                                                                            {/* {t('EncroachmentDashboard.View')} */}
                                                                            <i class="fa-regular fa-image"></i>
                                                                        </button>

                                                                }

                                                            </td>
                                                            {
                                                                ((RoleID == 2) || (RoleID == 3) || (RoleID == 4) || (RoleID == 6)) &&
                                                                <td >{i.attendanceBy_OfficerName ? i.attendanceBy_OfficerName : '-'}</td>
                                                            }


                                                        </tr>
                                                    )
                                                })
                                                    :
                                                    <tr>
                                                        <td colSpan={12}>No data found ...</td>
                                                    </tr>
                                            }
                                        </tbody>


                                    </table>
                                </div>
                                {tableData && tableData.length > 0 &&
                                    <Pegination
                                        PerPageCount={PerPageCount}
                                        TotalCount={tableData && tableData[0].totalCount}
                                        setFrom={setFrom}
                                        setTo={setTo}
                                        CurrentPage={CurrentPage}
                                        setCurrentPage={setCurrentPage}
                                        IsClear={IsClear}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {
                showImagePopup ?
                    <ViewURL
                        Heading={t('EncroachmentDashboard.View')}
                        setshowImagePopup={setshowImagePopup}
                        ImagePopUpData={ImagePopUpData}

                    />
                    : ''
            }
        </>
    )
}

